import * as React from 'react';
import { FastField, FastFieldProps } from 'formik';

const { CheckBox } = require('@cvent/carina-checkbox');

import { FormikValues } from '../FilterBar';
import { ContentCollapsible, ContentPersistent, InputGroupPanel } from '../../input-group-panel/';

const _styles = require('./CheckboxSetField.scss');

interface CheckboxProps {
    setName: string;
    name: string;
    value: string;
}

interface CheckboxSetProps {
    name: string;
    options: [string, string][];
}

const CheckboxField = (props: CheckboxProps) => {
    const { setName, name, value: v } = props;
    const fieldName = `${setName}.${v}`;

    return (
        <FastField name={fieldName}>
            {(props: FastFieldProps<FormikValues>) => {
                const { field } = props;
                const { value, onChange, ..._field } = field;

                return (
                    <CheckBox {..._field} id={field.name} checked={value} onChange={onChange}>
                        {name}
                    </CheckBox>
                );
            }}
        </FastField>
    );
};

export const CheckboxSetField = (props: CheckboxSetProps) => {
    return (
        <div className={_styles.checkboxSetField}>
            <InputGroupPanel collapsible={true} defaultCollapsed={true} seeMoreText={'See All'}>
                <ContentPersistent>
                    {props.options.slice(0, 3).map((option) => (
                        <CheckboxField key={option[0]} setName={props.name} value={option[0]} name={option[1]} />
                    ))}
                </ContentPersistent>
                <ContentCollapsible>
                    {() => (
                        <>
                            {props.options.slice(3).map((option) => (
                                <CheckboxField key={option[0]} setName={props.name} value={option[0]} name={option[1]} />
                            ))}
                        </>
                    )}
                </ContentCollapsible>
            </InputGroupPanel>
        </div>
    );
};
